import { Link } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import MemberService from "../../services/MemberService";

function OrgPrivacyPolicyLink({ children, underline }) {
    const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState("");
    
    useEffect(() => {
        const source = axios.CancelToken.source();
        
        MemberService.getPrivacyPolicyLink(source.token)
            .then(url => {
                if (url) {
                    setPrivacyPolicyUrl(url);
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.error("Error loading privacy policy link:", error);
                    // Fallback to a default URL if needed
                    setPrivacyPolicyUrl("https://example.com/privacy-policy");
                }
            });
            
        return function cleanup() {
            source.cancel();
        };
    }, []);
    
    return (
        <Link 
            underline={underline || "always"}
            target="_blank"
            rel="noreferrer"
            href={privacyPolicyUrl || "#"}
        >
            {children || "Privacy Policy"}
        </Link>
    );
}

export default OrgPrivacyPolicyLink;
